import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const TwoColumn3070 = createSvgIcon(
  <svg id="Layer_1" viewBox="0 0 48 48" x="0px" y="0px" version="1.1">
    <g id="Two-Column-30-70">
      <g id="Group-4" transform="translate(2 4)">
        <g id="Rectangle-Copy-13">
          <path d="M 7.3 39.1 H 0 V 0 h 7.3 V 39.1 Z M 0.5 38.6 h 6.3 V 0.5 H 0.5 V 38.6 Z" />
        </g>
        <g id="Rectangle-Copy-14">
          <path d="M 44 39.1 H 12.2 V 0 H 44 V 39.1 Z M 12.7 38.6 h 30.8 V 0.5 H 12.7 V 38.6 Z" />
        </g>
      </g>
    </g>
  </svg>,
  'TwoColumn3070'
);
